<script>
// Components
import {
  PaymentList,
  PaymentListDivider,
  PaymentListItem
} from '@/components/page/payment-list'

// Functions
import { toThaiDatetime } from '@/utils/datetime'

const Item = ({ props, slots }) => (
  <li>
    <el-row
      type="flex"
      gutter={16}
      style={{ marginBottom: '0.5rem', fontSize: '1rem' }}
    >
      <el-col
        span={null}
        style={{ width: '10rem', textAlign: 'right', flexShrink: '0' }}
      >
        {props.label}
      </el-col>
      <el-col span={null} style={{ flex: '1', fontWeight: 'bold' }}>
        {slots().default}
      </el-col>
    </el-row>
  </li>
)

export default {
  props: {
    date: {
      type: Date,
      default: null
    },

    dueDate: {
      type: Date,
      default: null
    },

    amount: {
      type: Number,
      default: 0
    }
  },

  render() {
    return (
      <div>
        <PaymentList header="รายการต่อขายฝาก">
          <Item label="วันที่รับชำระดอกเบี้ย:">
            {toThaiDatetime(this.date)}
          </Item>
          <Item label="วันที่ครบกำหนดใหม่:">
            {toThaiDatetime(this.dueDate)}
          </Item>
          <PaymentListDivider />
          <PaymentListItem
            title="ยอดรับชำระดอกเบี้ย:"
            value={this.amount}
            scopedSlots={{
              title: title => <div style={{ fontSize: '1rem' }}>{title}</div>
            }}
          />
        </PaymentList>
      </div>
    )
  }
}
</script>
